import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ExportersApi } from 'api';

/**
 * Custom React Query hook to delete a seller
 *
 * @param {{ onSuccess?: () => void; onError?: (error: Error) => void }} options
 * @returns {import("@tanstack/react-query").UseMutationResult}
 */
export function useDeleteExporter({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => ExportersApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['exporters']);
      typeof onSuccess === 'function' && onSuccess();
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
}
